import card1Svg from '../../../assets/icons/home-v2/card-1.svg';
import card2Svg from '../../../assets/icons/home-v2/card-2.svg';
import card3Svg from '../../../assets/icons/home-v2/card-3.svg';
import handSvg from '../../../assets/icons/home-v2/hand.svg';
import { INTRO_CARD } from './constants';

// Copied from CardSwipeIntroModal — moved here before that file is deleted in Phase 4
function SwipeArrowSvg() {
  return (
    <svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 39C3 24.0883 15.0883 12 30 12" stroke="#1B2831" strokeWidth="6" strokeLinecap="round" />
      <path d="M26.7581 3L37.0267 11.7581L28.2686 22.0267" stroke="#1B2831" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function IntroCardDeckCard() {
  return (
    <div
      className={`flex flex-col w-full aspect-[382/462] overflow-hidden ${INTRO_CARD.padding} ${INTRO_CARD.gap}`}
      style={{
        background: '#1B2831',
        borderRadius: '24px',
        boxShadow: '0px 4px 16px rgba(0, 117, 141, 0.2)',
      }}
    >
      {/* Illustration area — cards are pre-rotated in SVG, no CSS rotation needed */}
      <div className="relative flex-shrink-0" style={{ height: '55%', borderRadius: '12px' }}>
        {/* card-1: back-left, pink, baked at −14° */}
        <img
          src={card1Svg}
          alt=""
          aria-hidden="true"
          className="absolute bottom-0"
          style={{ width: '55%', left: '18%' }}
        />
        {/* card-2: center, green, upright, has baked drop-shadow */}
        <img
          src={card2Svg}
          alt=""
          aria-hidden="true"
          className="absolute bottom-0"
          style={{ width: '55%', left: '50%', transform: 'translateX(-50%)', zIndex: 10 }}
        />
        {/* card-3: top-right, lavender, baked at +10° */}
        <img
          src={card3Svg}
          alt=""
          aria-hidden="true"
          className="absolute bottom-0"
          style={{ width: '63%', right: '5%', bottom: '-14%', zIndex: 20 }}
        />
        {/* Hand + arrow overlay */}
        <div className="absolute z-30" style={{ width: '22%', bottom: '8%', left: '52%' }}>
          <img src={handSvg} alt="" aria-hidden="true" style={{ width: '100%' }} />
          <div className="absolute" style={{ width: '55%', top: '-40%', right: '50%' }}>
            <SwipeArrowSvg />
          </div>
        </div>
      </div>

      {/* Title — direct flex child, shares outer gap */}
      <p
        className={`${INTRO_CARD.typography.title} mt-4 text-white text-center w-full shrink-0`}
        style={{ fontVariationSettings: "'opsz' 14" }}
      >
        Swipe to explore today's sparks
      </p>

      {/* Subtitle — direct flex child, shares outer gap */}
      <p
        className={`${INTRO_CARD.typography.subtitle} text-white text-center w-full shrink-0`}
        style={{ fontVariationSettings: "'opsz' 14" }}
      >
        Tiny ideas for everyday moments.
      </p>
    </div>
  );
}
